import axios from 'axios'
import { API_PREFIX } from '../constants'

// TODO, 请求埋点上报
const fetch = params => {
    const { method = 'get', url = '', data = {}, opts = {} } = params
    const options = {
        method,
        url: API_PREFIX + url,
        ...opts,
    }
    if (method.toLowerCase() === 'get') {
        options.params = data
    } else if (method.toLowerCase() === 'post') {
        options.data = data
    }

    return new Promise((resolve, reject) => {
        axios(options)
            .then(res => {
                if (res.status === 200 && res.data) {
                    resolve(res.data)
                } else {
                    reject(`网络错误，HTTP请求返回码 ${res.status}`)
                }
            })
            .catch(error => {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data)
                    // console.log(error.response.status)
                    // console.log(error.response.headers)
                    reject(`网络错误，HTTP请求返回码 ${error.response.status}`)
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // console.log(error.request);
                    reject(`网络错误，HTTP请求返回内容为空`)
                } else {
                    // Something happened in setting up the request that triggered an Error
                    reject(`网络错误，${error.message}`)
                }
            })
    })
}

export default fetch
